module.exports = __webpack_public_path__ + "static/media/komf2.71afbde2.jpg";